<div class="formGroup listaDias" *ngIf="agendaForm" [formGroup]="agendaForm">
  <div class="divFecha encabezadoCols">
    <span></span>
    <span class="colHeader">Franja 1 desde</span>
    <span class="colHeader">Franja 1 hasta</span>
    <span class="colHeader">Franja 2 desde</span>
    <span class="colHeader">Franja 2 hasta</span>
  </div>

  <div class="divFechas" *ngFor="let d of dias">
    <div class="divFecha" [class.error]="getDiasConConflicto(d.key)">
      <span class="dia">{{ d.label }}</span>

      <div class="fecha">
        <mat-form-field class="formFieldFecha">
          <input
            class="inputFecha"
            matInput
            placeholder="--:--"
            [format]="24"
            [ngxTimepicker]="picker1Desde"
            [formControlName]="d.key + 'Desde'"
            readonly
          />
        </mat-form-field>
        <ngx-material-timepicker [theme]="darkTheme" #picker1Desde></ngx-material-timepicker>
        <div class="borrar divIcon" (click)="borrarFecha(d.key + 'Desde')">
          <mat-icon class="icon">delete_forever</mat-icon>
        </div>
      </div>

      <div class="fecha">
        <mat-form-field class="formFieldFecha">
          <input
            class="inputFecha"
            matInput
            placeholder="--:--"
            [format]="24"
            [ngxTimepicker]="picker1Hasta"
            [formControlName]="d.key + 'Hasta'"
            readonly
          />
        </mat-form-field>
        <ngx-material-timepicker [theme]="darkTheme" #picker1Hasta></ngx-material-timepicker>
        <div class="borrar divIcon" (click)="borrarFecha(d.key + 'Hasta')">
          <mat-icon class="icon">delete_forever</mat-icon>
        </div>
      </div>

      <div class="fecha">
        <mat-form-field class="formFieldFecha">
          <input
            class="inputFecha"
            matInput
            placeholder="--:--"
            [format]="24"
            [ngxTimepicker]="picker2Desde"
            [formControlName]="d.key + 'Desde2'"
            readonly
          />
        </mat-form-field>
        <ngx-material-timepicker [theme]="darkTheme" #picker2Desde></ngx-material-timepicker>
        <div class="borrar divIcon" (click)="borrarFecha(d.key + 'Desde2')">
          <mat-icon class="icon">delete_forever</mat-icon>
        </div>
      </div>

      <div class="fecha">
        <mat-form-field class="formFieldFecha">
          <input
            class="inputFecha"
            matInput
            placeholder="--:--"
            [format]="24"
            [ngxTimepicker]="picker2Hasta"
            [formControlName]="d.key + 'Hasta2'"
            readonly
          />
        </mat-form-field>
        <ngx-material-timepicker [theme]="darkTheme" #picker2Hasta></ngx-material-timepicker>
        <div class="borrar divIcon" (click)="borrarFecha(d.key + 'Hasta2')">
          <mat-icon class="icon">delete_forever</mat-icon>
        </div>
      </div>
    </div>

    <div *ngIf="agendaForm.hasError(d.key + 'Error1')" class="errorDiv">
      Falta la hora de fin de la franja 1.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error2')" class="errorDiv">
      Falta la hora de inicio de la franja 1.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error3')" class="errorDiv">
      La hora de fin debe ser posterior a la de inicio.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error4')" class="errorDiv">
      Falta la hora de fin de la franja 2.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error5')" class="errorDiv">
      Falta la hora de inicio de la franja 2.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error6')" class="errorDiv">
      La hora de fin de la franja 2 debe ser posterior a la de inicio.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error7')" class="errorDiv">
      Para cargar la franja 2 primero hay que completar la franja 1.
    </div>
    <div *ngIf="agendaForm.hasError(d.key + 'Error8')" class="errorDiv">
      La franja 2 debe comenzar después de que termina la franja 1.
    </div>
  </div>

  <div *ngIf="agendaForm.hasError('fechasError')" class="errorDiv">
    Si la agenda está habilitada, debe haber al menos un día con horarios cargados.
  </div>
</div>
